import { render, staticRenderFns } from "./ed-lesson-create-video.vue?vue&type=template&id=0f4c9b00&scoped=true&"
import script from "./ed-lesson-create-video.ts?vue&type=script&lang=ts&"
export * from "./ed-lesson-create-video.ts?vue&type=script&lang=ts&"
import style0 from "./ed-lesson-create-video.scss?vue&type=style&index=0&id=0f4c9b00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4c9b00",
  null
  
)

export default component.exports